import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { PermissionService } from '../../../core/services/permission.service';
import { BackButtonComponent } from '../../../shared/components/back-button/back-button.component';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { NavListItemComponent } from '../../../shared/components/nav-list-item/nav-list-item.component';
import { HasPermissionDirective } from '../../../shared/directives/has-permission.directive';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

/** Landing page for /settings -- just a list of section titles; tapping one
 *  navigates to that section's routed content (see settings.component for
 *  the shell that hosts the slide transition between this and a section). */
@Component({
  selector: 'app-settings-home',
  standalone: true,
  imports: [RouterLink, BackButtonComponent, IconComponent, NavListItemComponent, HasPermissionDirective, TranslatePipe],
  templateUrl: './settings-home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './settings-home.component.css',
})
export class SettingsHomeComponent {
  private permissionService = inject(PermissionService);

  isSuperAdmin(): boolean {
    return this.permissionService.isSuperAdmin();
  }
}
